module.exports = __webpack_public_path__ + "img/CM-EC-26-Mitsubishi-Playful.922e9bdf.jpg";